export default html => {
  let parser = new DOMParser().parseFromString(html, "text/html");
  return parser.documentElement.textContent;
};
